// Annotated image popover initalization

jQuery( function ( $ ) {
    $( '[data-toggle="popover"]' ).popover();

    var $imageWrapper = $( '.annotated-image-wrapper' );
    var $image = $( '.annotated-image' );

    $imageWrapper.imagesLoaded( function () {
        $imageWrapper.addClass('loaded');
        $image.hover( function () {
            $( this ).popover( 'show' );
        }, function () {
            $( this ).popover( 'hide' );
        } );
    } );

} );